
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './styles.module.scss';

const propTypes = {
  active: PropTypes.bool.isRequired
};

const LetterLine = ({active}) => (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width="596"
    height="989"
    fill="none"
    viewBox="0 0 596 989"
    className={classNames({
        [styles.active]: active
    })}
  >
    <path
      stroke="#D5FF4D"
      strokeLinecap="round"
      strokeWidth="2"
      d="M-46 24c.687-6.869 9.855-12.919 15.333-16 16.21-9.118 38.95-6.647 56.778-5.778 51.5 2.512 98.327 47.236 105.445 97.334 3.661 25.767 3.788 52.691-1.556 78.222-4.424 21.135-18.466 45.619-15.444 67.778 2 14.671 20.581 19.121 32.444 21.333 20.859 3.889 48.372 9.334 68.333-.222 36.754-17.595 51.024-67.44 53.667-104.445 1.384-19.373.796-59.735-27.444-60.222-9.54-.164-12.186 1.039-14.667 11.111-3.267 13.261-1.094 31.53 3.555 44C240.979 185.364 264.965 207.056 281 232c5.61 8.727 14.946 6.712 24.667 8.444 56.311 10.036 107.076 55.18 141.222 98.445 42.515 53.869 70.466 116.509 74.222 186 5.309 98.219-29.018 189.257-76.333 273.333-34.085 60.567-81.121 113.305-137.556 153.667C279.766 971.525 254.272 984 220 984c-34.649 0-42.764-55.144-45.889-80.667-1.441-11.765-7.793-39.128-.222-49.222 15.209-20.279 63.962-11.93 83.667-9.222 47.869 6.577 95.342 27.979 139.333 46.889 42.699 18.354 84.347 39.173 127.222 57.111 23.869 9.986 47.754 18.482 72.333 26.333C608.863 979.189 622.694 986 636 986c26.801 0 57.809-4.548 84 2"
      className={styles['svg-elem']}
     />
  </svg>
);

LetterLine.propTypes = propTypes;

export default LetterLine;
